import type { Auth0User } from 'paintscout'
import type { Owner, User } from '@paintscout/api'
import { removeAuth0Prefix } from '../../../users/removeAuth0Prefix'

export function getOwnerFromUser(user: Auth0User | User): Owner {
  if (!user) {
    return null
  }
  return {
    id: removeAuth0Prefix(user.user_id),
    firstName: user.user_metadata.firstName,
    lastName: user.user_metadata.lastName,
    email: user.email,
    phoneNumber: user.user_metadata.phoneNumber,
    phoneExtension: user.user_metadata.phoneExtension,
    title: user.user_metadata.title
  }
}
